import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"

const textValue = (value: unknown): string => {
  if (typeof value === "string" && value.trim()) return value.trim()

  if (typeof value === "number" && Number.isFinite(value)) return String(value)

  return ""
}

export const cellText = (props: InboxWorkflowCellProps, fallbackKey?: string): string => {
  const bindingValue = textValue(props.binding.value)

  if (bindingValue) return bindingValue

  return fallbackKey ? textValue(props.row[fallbackKey]) : ""
}

export const rowStatusLabel = (props: InboxWorkflowCellProps): string =>
  textValue(props.row.statusLabel) || "Offen"

export const rowStatusDetail = (props: InboxWorkflowCellProps): string | null =>
  textValue(props.row.statusDetail) || null

export const rowStatusHint = (props: InboxWorkflowCellProps): string | null =>
  textValue(props.row.statusHint) || null
